import { Checkbox, FormControlLabel } from '@mui/material';
import { styled } from '@mui/material/styles';
import { RefObject } from 'react';

interface AgreementCheckboxProps {
    checkboxChecked: boolean;
    checkboxChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    checkboxValue: RefObject<HTMLInputElement>;
    label: string | React.ReactNode;
}

const StyledFormControlLabel = styled(FormControlLabel)(({ theme }) => ({
    alignItems: 'flex-start',
    marginTop: theme.spacing(1),
    marginLeft: 0,
    marginRight: 0,
    '& .MuiCheckbox-root': {
        marginRight: '10px',
        marginTop: '-8px',
        marginLeft: '-10px',
    },
    '& .MuiFormControlLabel-label': {
        lineHeight: 1.6,
    },
}));

export default function AgreementCheckbox({
                                              checkboxChecked,
                                              checkboxChange,
                                              checkboxValue,
                                              label,
                                          }: AgreementCheckboxProps) {
    return (
        <StyledFormControlLabel
            control={
                <Checkbox
                    checked={checkboxChecked}
                    onChange={checkboxChange}
                    inputRef={checkboxValue}
                    color="primary"
                    size="medium"
                />
            }
            label={label}
        />
    );
}
